import { Trans } from '@lingui/react/macro';

import { LinkButton } from '@/components/buttons';
import { Link, Text } from '@/components/typography';
import { ROUTES } from '@/router';

import { type WidgetNotAvailableType } from './types';

const NotAvailable = ({ cta, docsLink }: WidgetNotAvailableType) => (
  <div className="absolute inset-0 bg-gray-800/70">
    <div className="absolute top-1/2 left-1/2 flex -translate-1/2 flex-col items-center gap-4 text-center">
      <Text variant="label" color="white">
        {cta}
      </Text>
      <LinkButton variant="primary" to={ROUTES.pixels.path}>
        <Trans>Take Me There</Trans>
      </LinkButton>
      {docsLink && (
        <Text variant="label" color="white">
          <Trans>or read about it</Trans>{' '}
          <Link color="static-white" to={docsLink}>
            <Trans>here</Trans>
          </Link>
        </Text>
      )}
    </div>
  </div>
);

export default NotAvailable;
